import Avatar from './src/Avatar.vue'

export default Avatar
